import * as React from 'react'
import ReactDOM from 'react-dom';

import { Tooltip } from './tooltip'

const getElementPosition = e => e.currentTarget.getBoundingClientRect()

export class ElementTooltip extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = { targetElement: null, tooltip: null }
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
  }

  renderTooltip = () => {
    const {
      id,
      position,
      tooltipWidth,
      speed,
      size,
      text,
      hotKey,
      picture,
      description,
      wordBreakAll,
      tooltipOverflow,
      isTranslucent,
    } = this.props;
    const modalRoot = document.getElementById('modal-root');
    const targetElement = this.state.targetElement;
    return ReactDOM.createPortal(
      (
        <Tooltip
          id={id}
          targetTop={targetElement.top}
          targetBottom={targetElement.bottom}
          targetLeft={targetElement.left}
          targetRight={targetElement.right}
          targetWidth={targetElement.width}
          targetHeight={targetElement.height}
          position={position}
          tooltipWidth={tooltipWidth}
          wordBreakAll={wordBreakAll}
          size={size}
          text={text}
          speed={speed}
          hotKey={hotKey}
          picture={picture}
          description={description}
          tooltipOverflow={tooltipOverflow}
          isTranslucent={isTranslucent}
        />
      ),
      modalRoot,
    );
  }

  render() {
    const { disabled, children } = this.props;
    if (!children) {
      return null
    }

    if (disabled) {
      return children;
    }

    return (
      <>
        <div
          onMouseEnter={this.onMouseEnter}
          onMouseLeave={this.onMouseLeave}
          onClick={this.onMouseLeave}
        >
          {children}
        </div>
        {this.state.tooltip && this.renderTooltip()}
      </>
    )
  }


  onMouseEnter(el) {
    this.setState({ targetElement: getElementPosition(el), tooltip: true });
  }

  onMouseLeave() {
    this.setState({ tooltip: false });
  }
}
